// ─── 주문 상태 ───
export type OrderStatus =
  | "pending"
  | "paid"
  | "processing"
  | "completed"
  | "cancelled";

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  pending: "주문대기",
  paid: "결제완료",
  processing: "제작중",
  completed: "완료",
  cancelled: "취소",
};

export const ORDER_STATUS_CONFIG: Record<
  OrderStatus,
  { color: string; icon: string; label: string }
> = {
  pending: {
    color: "bg-amber-100 text-amber-700",
    icon: "ri-time-line",
    label: "주문대기",
  },
  paid: {
    color: "bg-blue-100 text-blue-700",
    icon: "ri-bank-card-line",
    label: "결제완료",
  },
  processing: {
    color: "bg-violet-100 text-violet-700",
    icon: "ri-loader-4-line",
    label: "제작중",
  },
  completed: {
    color: "bg-green-100 text-green-700",
    icon: "ri-check-line",
    label: "완료",
  },
  cancelled: {
    color: "bg-red-100 text-red-700",
    icon: "ri-close-line",
    label: "취소",
  },
};

// ─── 주문 선택 ───
export interface OrderSelection {
  categoryKey: string;
  styleName: string;
}

// ─── 주문 사진 ───
export interface OrderPhoto {
  uploadIdx: number;
  s3Key: string;
  url: string;
}

// ─── 생성 이미지 ───
export interface GeneratedImage {
  imageIdx: number;
  generatedImageIdx?: number;
  url: string;
  imageUrl?: string;
  s3Key?: string;
  thumbnailUrl?: string;
  categoryKey: string;
  createdAt: string;
}

// ─── 주문 목록 아이템 ───
export interface Order {
  orderIdx: number;
  orderId: string;
  planIdx: number;
  productName: string;
  amount: number;
  status: OrderStatus;
  statusLabel: string;
  photoCount: number;
  createDt: string;
  tid?: string;
  paymentStatus?: string;
  // 상세 조회 시 추가 필드
  selections?: OrderSelection[];
  estimatedDelivery?: string;
  completedAt?: string;
}

// ─── 주문 상세 ───
export interface OrderDetail extends Order {
  customerName: string;
  customerPhone: string;
  customerEmail: string;
  selections: OrderSelection[];
  photos: OrderPhoto[];
  generatedImages: GeneratedImage[];
}

// ─── 주문 생성 요청 ───
export interface CreateOrderRequest {
  planIdx: number;
  expectedAmount: number;
  customerInfo: {
    name: string;
    phone: string;
    email: string;
  };
  uploadedFileKeys: string[]; // s3Key 배열
  selections: {
    categoryKey: string;
  }[];
}

// ─── 고객용 생성 이미지 (재생성 정보 포함) ───
export interface CustomerGeneratedImage {
  generatedImageIdx: number;
  imageUrl: string;
  s3Key: string;
  categoryKey: string;
  sortOrder: number;
  regenCount: number;
  maxRegenCount: number;
  canRegenerate: boolean;
  createDt: string;
}

export interface CustomerImageResponse {
  images: CustomerGeneratedImage[];
  maxRegenCount: number;
  maxDownloadCount: number;
}

// ─── AI 생성 상태 ───
export interface GenerationJob {
  jobIdx: number;
  orderIdx: number;
  status: "queued" | "processing" | "completed" | "failed";
  progress: number;
  totalImages: number;
  generatedCount: number;
  generatedImages?: GeneratedImage[];
}
